<template>
  <div>
    <Head :title="`Delivery Run #${delivery_run.number} Orders`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-orange-600 hover:text-orange-500"
        href="/invoice-validation-queue"
        >{{ delivery_run.number }}</Link
      >
      - Orders
    </h1>
    <div class="mb-3">
      <Link
        href="/invoice-validation-queue"
        class="text-orange-600 hover:text-orange-500 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        Back
      </Link>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md">
        <label class="block text-gray-700">Role:</label>
      </search-filter>
      <a
        class="btn-orange ml-auto"
        href="#"
        @click="openModal"
      >
        Generate Invoice
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3 border border-dark">Date</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Channel</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Order Number</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Customer</th>
          <th class="pb-3 pt-3 px-3 border border-dark text-center">Quantity Ordered</th>
          <th class="pb-3 pt-3 px-3 border border-dark text-center">Quantity Packed</th>
        </tr>
        <tr
          v-for="listp in delivery_runs.data"
          :key="listp.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.invoice_date }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.channel }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.order_no }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.customer }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center justify-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.quantity_ordered }}
            </Link>
          </td>
          <td class="border-t border border-dark">
            <Link
              class="flex items-center justify-center px-3 py-3 focus:text-orange-500"
              :href="`/invoice-validation/delivery-runs/${delivery_run.id}/orders/${listp.order_id}/details`"
              title=""
            >
              {{ listp.quantity_packed }}
            </Link>
          </td>
        </tr>
        <tr v-if="delivery_runs.data.length === 0">
          <td class="px-3 py-3 border-t border border-dark" colspan="6">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="delivery_runs.links" />
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-12 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Generate Invoice</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="w-full lg:w-full pb-2 pr-6">
                <multiselect
                  id="entity"
                  v-model="form.processing_type"
                  placeholder="Search Processing Type"
                  :options="entities"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.processing_type"
                  :style="form.errors.processing_type ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                />
                <div v-if="form.errors.processing_type" class="form-error">{{ form.errors.processing_type }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submit">
                {{ buttonLabel }}
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import SearchFilter from "@/Shared/SearchFilter";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import Pagination from "@/Shared/Pagination";
import mapValues from "lodash/mapValues";
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    delivery_runs: Object,
    delivery_run: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        delivery_id: this.delivery_run.id,
        processing_type: '',
      }),
      entities: [
        {
          label : 'Taxilla',
          value : 'Taxilla',
        },
        {
          label : 'Direct',
          value : 'Direct',
        }
      ],
      isOpen: false,
      processing: false,
      buttonLabel: "Generate Invoices",
      search: {
        dateValue: this.filters.dateValue,
      },
    };
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role;
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get("/invoice-validation-queue/", pickBy(this.search), {
          preserveState: true,
        });
      }, 150),
    },
  },
  methods: {
    openModal() {
      this.isOpen = true
    },
    closeModal() {
      this.isOpen = false
      this.form.processing_type = null
      this.buttonLabel = "Generate Invoices";
    },
    reset() {
      this.search = mapValues(this.search, () => null);
    },
    submit() {
      this.processing = true;
      this.buttonLabel = "Generating Invoices..";
      this.form.post(
        `/invoice-validation/delivery-runs/${this.form.delivery_id}/mass-invoice-validation`,
        {
          onSuccess: () => {
            this.processing = false;
            this.buttonLabel = "Generate Invoices";
          },
        }
      );
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
